<template>
  <div>
    <template v-if="showActionControls">
      <div
        class="pa-3"
        v-for="c in contexts"
        v-show="c.groupId === group.id"
        :key="c.id"
      >
        <action-entertain-controls
          :context="c"
          :actionData="actionData"
          @update="updateAction(c)"
          @close="closeAction(c)"
        />
      </div>
    </template>

    <portal to="receivedAction">
      <action-entertain-content
        v-if="showActionContent(receivedState)"
        :class="actionContentClass"
        :state="receivedState"
      />
    </portal>
  </div>
</template>

<script>
import GenericAction from '../GenericAction';
import ActionEntertainControls from './ActionEntertainControls';
import ActionEntertainContent from './ActionEntertainContent';

export default {
  name: 'ActionEntertain',
  mixins: [GenericAction],
  components: {
    ActionEntertainControls,
    ActionEntertainContent,
  },
  data() {
    return {
      receivedState: {},
    };
  },
  methods: {
    selected() {
      this.addContext({
        show: false,
        videoUrl: '',
        audioUrl: '',
      });
    },

    updateAction(context) {
      this.api.trigger('stateChange', { contexts: this.contexts });
      this.updateParticipants(context);
    },

    received(data) {
      this.receivedState = data;
    },
  },
};
</script>

<style scoped>
video,
iframe {
  background: #004e75;
}
</style>
